import { render, staticRenderFns } from "./ResalesList.vue?vue&type=template&id=541133b2&"
import script from "./ResalesList.vue?vue&type=script&lang=js&"
export * from "./ResalesList.vue?vue&type=script&lang=js&"
import style0 from "./ResalesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports